module.exports = __webpack_public_path__ + "static/05-15eb430cddbac3d1d5d2e189354e874d.jpg";